import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Gestiona scroll global: sube al top salvo cuando regresamos desde un documento
// al listado, donde se intenta restaurar posición previamente guardada.

const RESTORE_KEYS = ['/admin', '/dashboard'];

export default function ScrollManager() {
  const location = useLocation();
  const navType = useNavigationType(); // POP, PUSH, REPLACE

  useEffect(() => {
    const fromDoc = sessionStorage.getItem('documentsListScrollPosition');
    if (RESTORE_KEYS.includes(location.pathname) && fromDoc) {
      // Restaurar y limpiar (se vuelve a guardar si el usuario entra de nuevo)
      const pos = parseInt(fromDoc, 10);
      requestAnimationFrame(() => window.scrollTo({ top: isNaN(pos) ? 0 : pos, behavior: 'instant' }));
      return;
    }
    // Para cualquier otra navegación (o si no hay posición), forzar top
    window.scrollTo({ top: 0, behavior: navType === 'POP' ? 'auto' : 'instant' });
  }, [location.pathname, navType]);

  return null;
}
